"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPages = exports.NUMBER_OF_PAGE_LINKS = void 0;
var NUMBER_OF_PAGE_LINKS = 7;
// max - DISCONNECTED_LENGTH is the start page index where paging
// should look like 1 ... 35 36 37 38 40
// 1 + DISCONNECTED_LENGTH is the end page index where paging
// should look like 1 2 3 4 5 ... 40
exports.NUMBER_OF_PAGE_LINKS = NUMBER_OF_PAGE_LINKS;
var LAYOUT_CHANGE_COUNT = 4;
var getPages = function getPages(currentPage, totalPages) {
  var leftChangePage = LAYOUT_CHANGE_COUNT + 1;
  var rightChangePage = totalPages - LAYOUT_CHANGE_COUNT;

  // always show first page link
  var pageList = [1];
  if (totalPages <= NUMBER_OF_PAGE_LINKS) {
    for (var i = 2; i <= totalPages; i++) {
      pageList.push(i);
    }
    return pageList;
  }
  if (currentPage < leftChangePage) {
    for (var _i = 2; _i <= leftChangePage; _i++) {
      pageList.push(_i);
    }
    pageList.push('jump-right');
    pageList.push(totalPages);
    return pageList;
  }
  if (currentPage >= leftChangePage && currentPage <= rightChangePage) {
    pageList.push('jump-left');
    pageList.push(currentPage - 1);
    pageList.push(currentPage);
    pageList.push(currentPage + 1);
    pageList.push('jump-right');
    pageList.push(totalPages);
    return pageList;
  }

  // currentPage > rightChangePage
  pageList.push('jump-left');
  for (var _i2 = rightChangePage; _i2 <= totalPages; _i2++) {
    pageList.push(_i2);
  }
  return pageList;
};
exports.getPages = getPages;